import React from 'react'
import ReactDOM from 'react-dom'

export default class Mode extends React.Component {

  render() {
    if (this.props.quote.available) {
      var modeClass = this.props.quote.mode == this.props.current_mode ? "col-12 col-md-4 p-1 mode active " : "col-12 col-md-4 p-1 mode "
      var modeImage = modes[this.props.quote.mode]
      return (
        <div className={modeClass + this.props.quote.mode} onClick={() => this.props.setMode(this.props.quote.mode)}>
          <div className="row m-1">
            <div className="col-6 col-md-12 illustration p-0">
              <div className="row">
                <div className="col-5 col-md-12 p-0">
                  <img src={modeImage} alt={this.props.quote.mode} className='img-fluid' />
                </div>
                <div className="col-7 col-md-12">
                  <span className="label">{I18n.t('modes.' + this.props.quote.mode)}</span>
                </div>
              </div>
            </div>
            <span className="col-4 col-md-12 price">
              { this.props.quote.customer_price_cents == 0 ?
                I18n.t('shared.select_mode.free')
                  :
                Number(this.props.quote.customer_price_cents / 100).toFixed(2) + " €"
              }
            </span>
            <span className="col-1 hidden-md-up pt-3 checked">
               <i className={this.props.quote.mode == this.props.current_mode  != "" ? "fa fa-check-circle" : "fa fa-circle-o"} />
            </span>
          </div>
        </div>
      )
    } else {
      return (
        <div></div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/Mode.jsx